import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=ca2efada&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=ca2efada&prod&lang=scss&scoped=true"
import style1 from "./Report.vue?vue&type=style&index=1&id=ca2efada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2efada",
  null
  
)

export default component.exports